import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

/**
 * Get privacy policy document
 * Public endpoint - no authentication required
 * @param {string} lang - Language code (uz or en)
 */
export const getPrivacyPolicy = async (lang = "uz") => {
  try {
    const response = await axios.get(`${API_URL}/legal/privacy-policy?lang=${lang}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching privacy policy:", error);
    throw error;
  }
};

/**
 * Get terms of service document
 * Public endpoint - no authentication required
 * @param {string} lang - Language code (uz or en)
 */
export const getTermsOfService = async (lang = "uz") => {
  try {
    const response = await axios.get(`${API_URL}/legal/terms-of-service?lang=${lang}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching terms of service:", error);
    throw error;
  }
};
